const CurrencyEnum = {
  GBP: 'GBP',
  PLN: 'PLN',
  EUR: 'EUR',
  CHF: 'CHF'
}

export default CurrencyEnum
